import { useState } from "react";
import NumberInput from "../shared/NumberInput";
import AddressAutocomplete from "../shared/AddressAutocomplete";
import StepNavigation from "../shared/StepNavigation";
import { ROIFormData } from "./ROISimulator";

interface Props {
  data: ROIFormData;
  onChange: (data: Partial<ROIFormData>) => void;
  onNext: () => void;
  onBack: () => void;
}

export default function Step2Verbrauch({ data, onChange, onNext, onBack }: Props) {
  const [errors, setErrors] = useState<{
    jahresverbrauch_kwh?: string;
    strompreis_ct?: string;
    postleitzahl?: string;
  }>({});

  const validate = () => {
    const e: typeof errors = {};
    if (!data.jahresverbrauch_kwh || data.jahresverbrauch_kwh < 500)
      e.jahresverbrauch_kwh = "Mindestens 500 kWh Jahresverbrauch.";
    if (!data.strompreis_ct || data.strompreis_ct < 10)
      e.strompreis_ct = "Bitte gültigen Strompreis eingeben.";
    if (!data.postleitzahl || !/^\d{5}$/.test(data.postleitzahl))
      e.postleitzahl = "Bitte gültige Postleitzahl (5 Ziffern) eingeben.";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  return (
    <div className="animate-slide-up" data-testid="step-2-verbrauch">
      <NumberInput
        label="Jährlicher Stromverbrauch"
        placeholder="z. B. 4000"
        unit="kWh"
        min={500}
        max={100000}
        value={data.jahresverbrauch_kwh ?? ""}
        onChange={(e) => onChange({ jahresverbrauch_kwh: parseFloat(e.target.value) || undefined })}
        error={errors.jahresverbrauch_kwh}
        hint="Typisches EFH: 3.500–5.000 kWh/Jahr. Steht auf Ihrer Jahresabrechnung."
        data-testid="jahresverbrauch-input"
      />

      <NumberInput
        label="Aktueller Strompreis"
        placeholder="37"
        unit="ct/kWh"
        min={10}
        max={80}
        value={data.strompreis_ct ?? ""}
        onChange={(e) => onChange({ strompreis_ct: parseFloat(e.target.value) || undefined })}
        error={errors.strompreis_ct}
        hint="Steht auf Ihrer Jahresabrechnung. Bundesdurchschnitt: ca. 37 ct/kWh (2026, BDEW)."
        data-testid="strompreis-input"
      />

      <AddressAutocomplete
        label="Postleitzahl / Adresse"
        onPlzSelect={(plz) => onChange({ postleitzahl: plz })}
        error={errors.postleitzahl}
        hint="Adresse eingeben → PLZ wird automatisch übernommen. Bestimmt den standortbezogenen Solarertrag."
      />

      <StepNavigation
        onBack={onBack}
        onNext={() => { if (validate()) onNext(); }}
        nextLabel="Zu Speicher & Einspeisung"
      />
    </div>
  );
}
